import axios from '../index'

export default {
    getEncuesta (encuestaId) {
        return axios.get(`/api/v1/encuestas/${encuestaId}`);
    },
    postGuardarRespuestas(formData){
        return axios.post('/api/v1/encuestas/guardar', formData)
    },
}